export default /* istanbul ignore next */ ({ spacing }) => ({
  body: {
    margin: 0,
    padding: `0 ${spacing.unit * 2}px`
  }
});
